import "./PastRentals.css";

function PastRentals(): JSX.Element {
    return (
        <div className="PastRentals">
			Past Rentals
        </div>
    );
}

export default PastRentals;
